import { render, staticRenderFns } from "./Medication.vue?vue&type=template&id=da0d5450&scoped=true&"
import script from "./Medication.vue?vue&type=script&lang=js&"
export * from "./Medication.vue?vue&type=script&lang=js&"
import style0 from "./Medication.vue?vue&type=style&index=0&id=da0d5450&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0d5450",
  null
  
)

export default component.exports